export default {"src":"/_next/static/media/Utah.cbd3af07.svg","height":798,"width":800,"blurWidth":0,"blurHeight":0};